/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * Bulk alert status update
 * @export
 * @interface InternalApiBulkCloseCommand
 */
export interface InternalApiBulkCloseCommand {
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiBulkCloseCommand
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {number}
     * @memberof InternalApiBulkCloseCommand
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBulkCloseCommand
     */
    newStatus: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBulkCloseCommand
     */
    comment: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalApiBulkCloseCommand
     */
    alertIds: Array<number>;
}



/**
 * Check if a given object implements the InternalApiBulkCloseCommand interface.
 */
export function instanceOfInternalApiBulkCloseCommand(value: object): value is InternalApiBulkCloseCommand {
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('newStatus' in value) || value['newStatus'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('alertIds' in value) || value['alertIds'] === undefined) return false;
    return true;
}

export function InternalApiBulkCloseCommandFromJSON(json: any): InternalApiBulkCloseCommand {
    return InternalApiBulkCloseCommandFromJSONTyped(json, false);
}

export function InternalApiBulkCloseCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBulkCloseCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'userId': json['userId'],
        'newStatus': json['newStatus'],
        'comment': json['comment'],
        'alertIds': json['alertIds'],
    };
}

export function InternalApiBulkCloseCommandToJSON(json: any): InternalApiBulkCloseCommand {
    return InternalApiBulkCloseCommandToJSONTyped(json, false);
}

export function InternalApiBulkCloseCommandToJSONTyped(value?: InternalApiBulkCloseCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'userId': value['userId'],
        'newStatus': value['newStatus'],
        'comment': value['comment'],
        'alertIds': value['alertIds'],
    };
}

